import React from 'react';
import Navbar    from './components/Navbar';
import Hero      from './components/Hero';
import About     from './components/About';
import Services  from './components/Services';
import Coverage    from './components/Coverage';
import Why       from './components/Why';
import Trustpilot  from './components/Trustpilot';
import Contact   from './components/Contact';
import Footer    from './components/Footer';

export default function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Coverage />
      <Why />
      <Trustpilot />
      <Contact />
      <Footer />
    </>
  );
}
